import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  isEmptyVal,
  isNotEmpty,
  displayField,
  removeHTMLTags,
} from "../../../utils/helpers";

const DescriptionCell = ({
  rowData,
  dataIndex,
  introLength,
  positionFromRight = "30",
  ...props
}: {
  rowData: any;
  dataIndex: string;
  introLength?: number;
  positionFromRight?: string;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  let desc = isNotEmpty(rowData[dataIndex])
    ? removeHTMLTags(rowData[dataIndex].toString())
    : "";
  const speaker = (
    <Popover title={t("DESCRIPTION")}>
      <div
        dangerouslySetInnerHTML={{
          __html: displayField(desc),
        }}
      />
    </Popover>
  );
  return (
    <Cell {...props}>
      <Whisper
        placement="left"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayField(desc.substring(0, introLength))}</a>
      </Whisper>
    </Cell>
  );
};

export default DescriptionCell;
